/**
 * You, at the top of a screen on a phone.
 *
 * The desktop layout keeps this in the left sidebar, which a phone does not
 * have. Rather than dropping it entirely, it becomes one row at the top of
 * the screens that had the sidebar beside them - the same information, in the
 * only place there is room for it.
 */

import { useSession } from '@/stores/session';
import { openUserCard } from './user';
import { UserName } from './user';
import { Avatar } from './Avatar';
import { Icon } from '@/icons/Icon';

export function MobileMe() {
  const me = useSession((s) => s.me);
  if (!me) return null;

  const roleLabel = me.role === 'admin' ? 'Admin' : me.role === 'mod' ? 'Moderator' : 'Member';
  const online = me.status !== 'offline' && me.status !== 'invisible';

  return (
    <button
      type="button"
      onClick={(e) => openUserCard(me, e.currentTarget)}
      className="flex flex-none items-center gap-3 rounded-[var(--radius-l)] border border-line-soft bg-surface-1 p-3 text-left transition-colors hover:bg-surface-2"
    >
      <Avatar user={me} size={46} presence />
      <span className="min-w-0 flex-1">
        <span className="flex items-center gap-1.5">
          <UserName user={me} className="truncate text-[15px] font-bold" />
          {me.role !== 'user' ? <Icon name="crown" size={13} className="flex-none text-accent-hi" /> : null}
        </span>
        <span className="block text-[12.5px] font-semibold text-accent-hi">{roleLabel}</span>
        <span className="flex items-center gap-1.5 text-[12px]">
          <i className={online ? 'h-2 w-2 rounded-full bg-good' : 'h-2 w-2 rounded-full bg-ghost'} />
          <span className={online ? 'text-good' : 'text-mute'}>{online ? 'Online' : 'Offline'}</span>
        </span>
      </span>
      <Icon name="chevronR" size={17} className="flex-none text-ghost" />
    </button>
  );
}
